import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

@Injectable()
export class CommissionAttachmentResolver implements Resolve<any> {

  constructor() {
  }

  resolve() {
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/service/commission-attachment.resolver.ts